import { IInterval } from "../../../../Context/Interval";
import { ISystemContext } from "../../../../Context/SystemContext";
import { ResourceIdentifier } from "../../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../../ResourceManager/ResourceManager";
import { CanvasSprite } from "../../../../slot/Sprite/CanvasSprite";
import { SlotGameInitData } from "../../../../SlotGameInitData";
import { LogGroup, Scale, CreateElement, Size } from "../../../.././MyHelpers";
import { Slide, SlideFactory2Params } from "./Slide";
import { ZIndex } from "../../../../ZIndex";
import { MyCanvas, MyCanvasContext } from "../../../MyCanvas";
export class WildSlideDoubleSlide extends Slide {
	protected logGroup: LogGroup = null;
	protected resid: ResourceIdentifier;
	protected systemContext: ISystemContext;



    protected wildTrigger: HTMLElement = null;
    protected wildDescription: HTMLElement = null;

    protected wildInstruction: HTMLElement = null;
    protected title: HTMLElement = null;

    protected WildSprite: CanvasSprite = null;

    
    protected TitleElement: HTMLElement = null;

    //CREATE A CANVAS FOR WINCOUNT
    protected titleCanvas: MyCanvas = null;
    protected ctx: MyCanvasContext = null;
    protected fontHeight: number = Scale.fh(70);

    protected SripiteTimer: IInterval;
    

    constructor(initData: SlotGameInitData,p: SlideFactory2Params , viewSize : Size) {
        super(initData, p , viewSize);

        this.resid = p.resid.Add("WildSlideDoubleSlide");
        this.logGroup = p.logGroup.Add("WildSlideDoubleSlide");
		this.systemContext = p.systemContext.CreateSubContext("WildSlideDoubleSlide");
        this.viewSize = viewSize;
        

		this.view = CreateElement("div", {
            classes: ["WildSlideDoubleSlide", this.resid.Scope()],
            style: {
                position: "absolute",
                height: this.viewSize.Height + "px",
                width: this.viewSize.Width + "px",

                display: "flex",
                flexDirection: "column",
                flexShrink: "0",
            }
        });

        this.TitleElement = CreateElement("div", {
            classes: ["TitleWild"],
            parentToAppend: this.view,
            style: {
                position: "absolute",
                height: Scale.Hpx(200),
                width: Scale.Wpx(450),
                fontSize: Scale.fhpx(55),
                color: "white",
            }
        });

        this.TitleCanvas();
    }

    protected TitleCanvas() {
        this.titleCanvas = new MyCanvas(new Size(Scale.W(450), Scale.H(200)), {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: "" + ZIndex.BonusWin,
            }
        });

        //add gradient
        this.ctx = this.titleCanvas.context;

        // this.ctx.font = "120px Verdana" /*+ this.font*/;
        this.ctx.font = "bold " + this.fontHeight + "px " + this.resid.ScopedResourceName("BonusWinFont");

        let color: string = "orangered";
        let color2: string = "yellow";

        let gradient = this.ctx.createLinearGradient(this.titleCanvas.size.Width / 2,
            this.titleCanvas.size.Height / 2 - this.fontHeight / 2,
            this.titleCanvas.size.Width / 2,
            this.titleCanvas.size.Height / 2 + this.fontHeight / 2
        );

        gradient.addColorStop(0, color);

        gradient.addColorStop(0.50, color2);

        gradient.addColorStop(1, color);

        this.ctx.fillStyle = gradient;
        this.ctx.shadowColor = "black";
        this.ctx.shadowOffsetX = 1;
        this.ctx.shadowOffsetY = 1;
        this.ctx.shadowBlur = 2;


        //this.ctx.textBaseline = "hanging";
        this.ctx.textBaseline = "top";
        this.ctx.textAlign = "center";


        this.TitleElement.appendChild(this.titleCanvas.view);

    }

    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {

    }

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

        // this.TitleCanvas();

    }

    public override Update() {

    }

    protected fillTextCanvas(CurrentWin: string) {
        //CHANGE SIMPLE TEXT TO CANVAS 
        this.ctx.clearRect(0, 0, this.titleCanvas.size.Width, this.titleCanvas.size.Height);

        this.ctx.strokeStyle = "black";
        this.ctx.lineWidth = Scale.XY(10);
        this.ctx.strokeText(CurrentWin, (this.titleCanvas.size.Width / 2), this.titleCanvas.size.Height / 4);

        this.ctx.strokeStyle = "white";
        this.ctx.lineWidth = Scale.XY(5);
        this.ctx.strokeText(CurrentWin, (this.titleCanvas.size.Width / 2), (this.titleCanvas.size.Height / 4));

        this.ctx.fillText(CurrentWin, (this.titleCanvas.size.Width / 2), (this.titleCanvas.size.Height / 4));
    }



    public override View(): HTMLElement {
        return this.view;
    }

    public override Start() {

    }

    public override Stop() {

    }


}